var React = require('react');

function SupportStatus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5 15a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm2.856-10.463l-4.02 4.111-1.72-1.64a.815.815 0 0 0-1.165.033.894.894 0 0 0 .037 1.249l2.293 2.19c.177.153.36.234.567.234.216 0 .425-.08.586-.243l4.6-4.69a.893.893 0 0 0-.003-1.248.818.818 0 0 0-1.175.004z","fill":"#424242","fillRule":"evenodd"}));
}

SupportStatus.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = SupportStatus;

SupportStatus.default = SupportStatus;
